// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-title[data-v-6f137588]{color:var(--main-green);font-size:1.3rem;font-weight:400;margin-bottom:5px}@media only screen and (max-width:600px){.home-title[data-v-6f137588]{padding:0 8px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
